import React from 'react';
import { View } from 'react-native';
import MyGreenCircle from '../components/MyGreenCircle';
import { Android, confirm_transfer_details, Thanks_for_your_help } from '../utils/DictionaryManagementUtils';

import SelectRecipientFP
  from '../components/SimulatorsComponents/FullPagesComponents/Services/Recipient/SelectRecipientFP';
import ConfirmTransferFP
  from '../components/SimulatorsComponents/FullPagesComponents/Services/Confirmation/ConfirmTransferFP';
import EnterAmountMenuFP
  from '../components/SimulatorsComponents/FullPagesComponents/Services/Amount/EnterAmountMenuFP';
import MenuToolsBarFP from '../components/SimulatorsComponents/FullPagesComponents/Services/MenuToolsBarFP';
import SimulatorsViewerArrangement
  from '../components/SimulatorsComponents/FullPagesComponents/SimulatorsViewerArrangement';
import { getRef } from '../utils/Utils';

//= ========================================================================
const Sim_X01_themeColors = ({
  globJSON,
  simPlatform,
  slideshowRefs,
}) => {
  const subCategoryId = 'send_money_0';
  const { layout_menu_screen } = globJSON.configurations.services.menu;

  return (
    <SimulatorsViewerArrangement>
      <View ref={getRef(slideshowRefs)}>
        <SelectRecipientFP
          globJSON={globJSON}
          simPlatform={simPlatform}
          subCategoryId={subCategoryId}
          isWithArrow
        />
        <MyGreenCircle value="A5" marginLeft={150} marginTop={simPlatform === Android ? '75%' : '108%'} />
        <MyGreenCircle value="A3" marginLeft={183} marginTop={simPlatform === Android ? '60%' : '95%'} />
        <MyGreenCircle value="B5" marginLeft={142} marginTop={simPlatform === Android ? '123%' : '155%'} />
        <MyGreenCircle value="B2" marginLeft={149} marginTop={simPlatform === Android ? '155%' : '177%'} />
      </View>

      <View ref={getRef(slideshowRefs)}>
        <ConfirmTransferFP
          globJSON={globJSON}
          simPlatform={simPlatform}
          confirmation={globJSON.configurations.services[subCategoryId].confirmation}
          subCategoryId={subCategoryId}
          headlineText={confirm_transfer_details}
          stringBottom={Thanks_for_your_help}
          scrollDisabled
        />
        <MyGreenCircle value="B1" marginLeft={10} marginTop={simPlatform === Android ? '48%' : '80%'} />
        <MyGreenCircle value="A2" marginLeft={130} marginTop={simPlatform === Android ? '90%' : '125%'} />
        <MyGreenCircle value="A1" marginLeft={110} marginTop={simPlatform === Android ? '125%' : '157%'} />
        <MyGreenCircle value="B1" marginLeft={20} marginTop={simPlatform === Android ? '152%' : '185%'} />
        <MyGreenCircle value="A4" marginLeft={170} marginTop={simPlatform === Android ? '150.5%' : '183.5%'} />
        <MyGreenCircle value="B6" marginLeft={170} marginTop={simPlatform === Android ? '73%' : '107%'} />
      </View>
      <View ref={getRef(slideshowRefs)}>
        <EnterAmountMenuFP
          globJSON={globJSON}
          simPlatform={simPlatform}
          subCategoryId={subCategoryId}
        />
        <MyGreenCircle value="B6" marginLeft={20} marginTop={simPlatform === Android ? '72%' : '105%'} />
        <MyGreenCircle value="B4" marginLeft={3} marginTop={simPlatform === Android ? '95%' : '128%'} />
        <MyGreenCircle value="A5" marginLeft={35} marginTop={simPlatform === Android ? '160%' : '175%'} />
      </View>
      <View ref={getRef(slideshowRefs)}>
        <MenuToolsBarFP
          globJSON={globJSON}
          simPlatform={simPlatform}
          force_display
          without_Top_title
        />
        <MyGreenCircle hideCircle={!layout_menu_screen} value="A6" marginLeft={175} marginTop={simPlatform === Android ? 170 : 245} />
        <MyGreenCircle hideCircle={!layout_menu_screen} value="A7" marginLeft={30} marginTop={simPlatform === Android ? 195 : 268} />
        <MyGreenCircle hideCircle={!layout_menu_screen} value="B7" marginLeft={130} marginTop={simPlatform === Android ? 145 : 225} />
        <MyGreenCircle hideCircle={!layout_menu_screen} value="B8" marginLeft={210} marginTop={simPlatform === Android ? 205 : 278} />
        <MyGreenCircle hideCircle={!layout_menu_screen} value="B9" marginLeft={160} marginTop={simPlatform === Android ? 380 : 435} />
      </View>
    </SimulatorsViewerArrangement>
  );
};

export default Sim_X01_themeColors;
